import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MessageNotifBannerComponent } from './message-notif-banner.component';

@NgModule({
    declarations: [MessageNotifBannerComponent],
    imports: [
        CommonModule
    ],
    exports: [MessageNotifBannerComponent]
})
export class MessageNotifBannerModule {
    constructor() { }
}
